import apiService from '@/services/apiService';

const actions = {
  getRates({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`marketing/rate?type=${payload}`)
        .then((response) => {
          commit('getRates', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getRateReports({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/rate/report/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getReasons({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('marketing/reason')
        .then((response) => {
          commit('getReasons', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReasonShipments({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('marketing/reason?type=shipment')
        .then((response) => {
          commit('getReasonShipments', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReasonFms({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('marketing/reason?type=fm')
        .then((response) => {
          commit('getReasonFms', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReasonLms({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('marketing/reason?type=lm')
        .then((response) => {
          commit('getReasonLms', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getRate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`marketing/rate/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getRate', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReason({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`marketing/reason/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getReason', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postRate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/rate', payload)
        .then((response) => {
          commit('postRate', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postReason({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/reason', payload)
        .then((response) => {
          commit('postReason', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateRates({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/rate/update-status', payload)
        .then((response) => {
          const object = {};
          payload.forEach((value, key) => { object[key] = value; });
          const json = JSON.stringify(object);
          commit('updateRates', json);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateReasons({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/reason/update-status', payload)
        .then((response) => {
          const object = {};
          payload.forEach((value, key) => { object[key] = value; });
          const json = JSON.stringify(object);
          commit('updateReasons', json);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putRate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`marketing/rate/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putRate', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putReason({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`marketing/reason/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putReason', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delRate({ commit }, payload) {
    apiService.delete(`marketing/rate/${payload}`)
      .then((response) => {
        commit('delRate', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  delReason({ commit }, payload) {
    apiService.delete(`marketing/reason/${payload}`)
      .then((response) => {
        commit('delReason', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
